/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowSmallDownIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAvUlEQVR4nO2QPQrCQBCFFxSsBQVvk3Yx2dlphhk9m2fRQgQLLUwKT+A5lHEJrEII+ev2g4H9gffmPWMSY+JQLuD5bKYCUN46yaARSBW1AamiGGvtIsuy+SQVqbhDfoGXe1HsVk0GlmjtUE6AcuhkQEQzFQ+C/FChfwN9Ay+V3h3KsXOKPN8vHfLtK+r5uSXa1AZhcy7jP9MHrUcTBKGw7c/ZS1Wn600eJ4lnyOatJn5E8bguh3zVGVxLwkR8AHc2jFPloni5AAAAAElFTkSuQmCC)
 */
export const ArrowSmallDownIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.7 20.7a1 1 0 0 1-1.4 0l-5-5a1 1 0 1 1 1.4-1.4l3.3 3.29V4a1 1 0 1 1 2 0v13.59l3.3-3.3a1 1 0 0 1 1.4 1.42l-5 5Z"
        className={colorClass}
      />
    </svg>
  );
};
